import { getCurrentUser, signOut } from 'aws-amplify/auth';
import * as Logger from 'services/logger';

export const validateSession = async (): Promise<boolean> => {
    try {
        const { userId } = await getCurrentUser();

        if (!userId) {
            throw new Error();
        }
    } catch {
        // Log at Datadog when the session expires
        Logger.logTerminatedSession(Logger.getSessionID());
        await signOut();
        return false;
    }

    return true;
};

export const validateAuthTokens = () => {
    /*
 		The threshold should follow the refreshToken expiration time.
  	TODO: find a way to get the refreshToken expiration time
  */
    const threshold = 5_000;
    setInterval(validateSession, threshold);
};
